"use strict";

let StyledSelect = {
    options: {
        selector: ".styled-select",
    },
};

StyledSelect.init = function (userOptions) {
    for (const prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);
}

StyledSelect.initSelectors = function (rootElement) {
    const select_elements = Array.prototype.slice.call(rootElement.querySelectorAll(this.options.selector), 0);

    select_elements.forEach( (select_element) => {
        if (select_element.hasOwnProperty('moduleStyledSelectInitialized')) { return; }
        select_element.moduleStyledSelectInitialized = true;

        const text_element = select_element.querySelector("span.selected-value");
        const input_element = select_element.querySelector("select");
        const option_elements = select_element.querySelectorAll(".dropdown-item:not(.search)");
        const dropdown_element = select_element.querySelector(".dropdown");
        const option_search_element = select_element.querySelector(".dropdown-item.search");

        input_element.parentNode.classList.add("is-hidden");
        dropdown_element.classList.remove("is-hidden");

        if (option_search_element) {
            option_search_element.addEventListener("click", (e) => {
                e.stopPropagation();
                e.preventDefault();
            });

            const search_input = option_search_element.querySelector("input");

            dropdown_element.querySelector("button,a").addEventListener("click", (e) => {
                e.preventDefault();

                if (dropdown_element.classList.contains("is-active")) {
                    search_input.focus();
                }
            });

            search_input.addEventListener("input", (e) => {
                option_elements.forEach( (option_element) => {
                    if (option_element.textContent.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(search_input.value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))) {
                        option_element.classList.remove("is-hidden");
                    }else{
                        option_element.classList.add("is-hidden");
                    }
                });
            });

            const button_delete = option_search_element.querySelector("button.delete");

            button_delete.addEventListener("click", (e) => {
                search_input.value = "";
                search_input.focus();
                option_elements.forEach( (option_element) => {
                    option_element.classList.remove("is-hidden");
                });
            });
        }

        option_elements.forEach( (option_element) => {
            if (option_element.dataset.value === input_element.value) {
                input_element.value = option_element.dataset.value;
                text_element.innerHTML = option_element.innerHTML;
                option_element.classList.add("is-active");
            }
            option_element.addEventListener("click", function (event) {
                input_element.value = option_element.dataset.value;
                text_element.innerHTML = option_element.innerHTML;
                option_elements.forEach((inner_option_element) => {
                    inner_option_element.classList.remove("is-active");
                });
                option_element.classList.add("is-active");
                dropdown_element.classList.remove("is-active");
            });
        });
    });
}

export {StyledSelect};